import { render, staticRenderFns } from "./k-v-panel.vue?vue&type=template&id=0bcdd357&scoped=true&"
import script from "./k-v-panel.vue?vue&type=script&lang=js&"
export * from "./k-v-panel.vue?vue&type=script&lang=js&"
import style0 from "./k-v-panel.vue?vue&type=style&index=0&id=0bcdd357&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcdd357",
  null
  
)

export default component.exports